import React, { useEffect, useState } from "react";
import { getGallery } from "../Service/Api";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import LazyLoad from "react-lazyload";
const Gallery = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const galleryData = await getGallery();
        setData(galleryData);
      } catch (error) {
        console.log("Error fetching gallery data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const empty = [
    { title: "Mata Mariyam Jan Sewa", img: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/gallery.jpg"},
    { title: "Mata Mariyam Jan Sewa", img: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/gallery.jpg"},
    { title: "Mata Mariyam Jan Sewa", img: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/gallery.jpg"}, 
  ];
  var settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <>
      <Slider {...settings}>
        {data.length > 0
          ? data.map((item, index) => (
              <div  className="item" key={index}>
                <div  className="galleryimg">
                  <div  className="galleryimgbox">
                    <LazyLoad
                      offset={10}
                      placeholder={
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/gallery.jpg" alt="Loading..."  className="img-fluid"/>
                      }>
                      <img
                        src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`}
                         className="img-fluid"
                        alt="Mata Mariyam Jan Sewa"
                      />
                    </LazyLoad>
                    <div  className="gallerydesc">
                      <Link to="/Gallery"  className="gallery_button">
                        View Gallery
                      </Link>
                      <h6>{item.title}</h6>
                    </div>
                  </div>
              </div>
            </div>
            )) : empty.map((item) => (
              <div  className="item" key={item.id}>
                <div  className="galleryimg">
                  <div  className="galleryimgbox">
                   <LazyLoad> <img
                      src={item.img}
                       className="img-fluid"
                      alt="Mata Mariyam Jan Sewa"
                    /></LazyLoad>
                    <div  className="gallerydesc">
                      <Link to="/Gallery"  className="gallery_button">
                        View Gallery
                      </Link>
                      <h6>{item.title}</h6>
                    </div>
                  </div>
                </div>
              </div>
            ))}
      </Slider>
    </>
  );
};

export default Gallery;
